import React from 'react';
import gql from 'graphql-tag';

import { Link } from 'react-router-dom';
import s from './JobsSlide.module.scss';
import EmblaCarousel from './EmblaCarousel/EmblaCarousel';
import getAssetLink from '../../../util/getAssetLink';
import AppContext, { AppContextType } from '../../../context';
import { ROUTE_PREFIX } from '../../../constants/router';
import { JOBS_VERSION } from '../../../constants/professions';

const professionsInRandomOrderQuery = gql`
  query professionsInRandomOrder {
    professionsInRandomOrder {
      key
      title
      slug
      imageName
    }
  }
`;

class JobsSlide extends React.Component {
  static contextType = AppContext;

  static randomProfessions: any;

  // eslint-disable-next-line react/state-in-constructor
  state: any;

  constructor(props: any) {
    super(props);

    this.state = {
      professions: [],
    };

    this.fetchRandomProfessions = this.fetchRandomProfessions.bind(this);
  }

  componentDidMount(): void {
    this.fetchRandomProfessions();
  }

  async fetchRandomProfessions() {
    try {
      if (JobsSlide.randomProfessions != null) {
        this.setState({
          professions: JobsSlide.randomProfessions,
        });
      } else {
        const result = await (this.context as AppContextType).client.query({
          query: professionsInRandomOrderQuery,
          fetchPolicy: 'network-only',
        });

        JobsSlide.randomProfessions = result.data.professionsInRandomOrder.map(
          (p: any) => ({
            ...p,
            imageName: `https://www.jopsy.at/appimages/jobs/${JOBS_VERSION}/${p.imageName}`,
            url: `${ROUTE_PREFIX}/beruf/${p.slug}`,
          }),
        );

        this.setState({
          professions: JobsSlide.randomProfessions,
        });
      }
    } catch (e: any) {
      // do nothing
    }
  }

  render() {
    return (
      <div className={s.jobsSlideContainer}>
        <div className={s.jobsSlideContainerInner}>
          <h2>Hier geht’s zu den Berufen!</h2>
          {this.state.professions.length > 0 && (
            <EmblaCarousel
              maxRenderedSlides={30}
              slidesData={this.state.professions}
              options={{
                loop: true,
                skipSnaps: true,
                breakpoints: {
                  '(max-width: 600px)': { skipSnaps: false }, // (max-width: $layout-breakpoint-3)
                },
              }}
            />
          )}
          <div className={s.buttonWrapper}>
            <Link
              className={`wideButton ${s.discoverMoreButton}`}
              to={`${ROUTE_PREFIX}/berufe-entdecken`}
              aria-label="Zur Berufsliste"
            >
              <span>ENTDECKE MEHR</span>
              <img src={getAssetLink('startpage/learn_more.png')} alt="" />
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default JobsSlide;
